import { useEffect, useState } from "react";

import { getChatClient } from "sj-ui-toolkit/src/client";

// Capabilities shown on the hero welcome. Empty while loading or if the request fails.
export function useChatCapabilities(tenant: string): string[] {
  const [capabilities, setCapabilities] = useState<string[]>([]);

  useEffect(() => {
    setCapabilities([]);
    if (!tenant) return;

    let cancelled = false;

    const load = async () => {
      const { data, error } = await getChatClient().getCapabilities(tenant);
      if (cancelled) return;

      if (error) {
        console.error("Error fetching chat capabilities:", error);
        setCapabilities([]);
        return;
      }
      setCapabilities(data.capabilities ?? []);
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [tenant]);

  return capabilities;
}
